export default __webpack_public_path__ + "static/logos1886-c4a5afc147e30780db8f257debf7b5fb.svg";